import axios from "axios";

function shouldFetch(state) {
    if (state().userList.isFetching) {
        return true;
    }
    return false;
}

export function fetchUsers() {
    return async function (dispatch, state) {
        if (shouldFetch(state)) {
            axios.get('/api/user')
                .then(res => {
                    dispatch({type: 'FETCH_USERS', payload: {users: res.data}})
                })
                .catch(error => {
                    console.log(error);
                });
        }
    }
}